








import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
	name: 'StartInterview',
})
export default class StartInterview extends Vue {
	public get applicationNumber(): string { return this.$store.getters['InterviewModule/applicationNumber'] }

	public async mounted() {
		this.$store.commit('InterviewModule/updateApplicationNumber', null); // Clear any existing value

		if (this.$route.params.applicationNumber) { // Resume application
			await this.$store.dispatch('InterviewModule/resumeInterview', this.$route.params.applicationNumber); // Call API to create a new Application record
			const pageName = this.$store.getters['InterviewModule/resumeSectionName'];

			//@ts-ignore
			this.$router.push({ name: pageName, params: { refreshFormData: true }, });
		}
		else { // Start new application
			await this.$store.dispatch('InterviewModule/startInterview'); // Call API to create a new Application record
			this.$router.push('/Interview/Filing');
		}
	}
}
